import React from 'react';
import { Collapse, Tag, Button, Row, Col, Select, Slider } from 'antd';

const { Panel } = Collapse;
const { Option } = Select;

function CustomPIISection({ config, updateConfig, customPIIForm, setCustomPIIForm, editingCustomPII, setEditingCustomPII }) {
  return (
    <Collapse
      ghost
      style={{ marginBottom: '24px' }}
    >
      <Panel
        header={
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span style={{ fontSize: '14px', fontWeight: 600, letterSpacing: '0.3px', color: '#262626' }}>
              🎨 CUSTOM PII TYPES
            </span>
            {config.custom_pii_types && config.custom_pii_types.length > 0 && (
              <Tag color="blue">{config.custom_pii_types.length} defined</Tag>
            )}
          </div>
        }
        key="custom"
      >
        <div style={{ padding: '4px 0' }}>
          {/* Existing Custom Types */}
          {config.custom_pii_types && config.custom_pii_types.length > 0 && (
            <div style={{ marginBottom: '16px', padding: '12px', backgroundColor: '#fafafa', borderRadius: '6px' }}>
              <div style={{ fontSize: '12px', fontWeight: 600, marginBottom: '12px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                Defined Custom Types
              </div>
              {config.custom_pii_types.map((customType, idx) => (
                <div
                  key={idx}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '14px',
                    backgroundColor: '#fff',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    border: '1px solid #e8e8e8',
                    transition: 'all 0.2s'
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: '8px' }}>
                      <strong style={{ fontSize: '13px', color: '#262626' }}>{customType.name}</strong>
                      <Tag color="blue" style={{ marginLeft: '8px' }}>{customType.severity}</Tag>
                      <Tag color="green" style={{ marginLeft: '4px' }}>
                        Confidence: {customType.base_confidence}%
                      </Tag>
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                      Pattern: <code style={{ backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: '3px', fontFamily: 'monospace' }}>{customType.regex}</code>
                    </div>
                    {customType.context_labels && customType.context_labels.length > 0 && (
                      <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>
                        Labels: {customType.context_labels.join(', ')}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                      size="small"
                      onClick={() => {
                        setCustomPIIForm({
                          name: customType.name,
                          regex: customType.regex,
                          severity: customType.severity,
                          base_confidence: customType.base_confidence,
                          context_labels: customType.context_labels?.join(', ') || '',
                          examples: customType.examples?.join(', ') || ''
                        });
                        setEditingCustomPII(idx);
                      }}
                    >
                      Edit
                    </Button>
                    <Button
                      size="small"
                      danger
                      onClick={() => {
                        const updated = config.custom_pii_types.filter((_, i) => i !== idx);
                        updateConfig('custom_pii_types', updated);
                      }}
                    >
                      Remove
                    </Button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Add/Edit Custom Type Form */}
          <div style={{
            padding: '16px',
            backgroundColor: editingCustomPII !== null ? '#fff4e6' : '#fafafa',
            borderRadius: '6px',
            border: editingCustomPII !== null ? '2px solid #ffa940' : '1px solid #e8e8e8',
            transition: 'all 0.3s'
          }}>
            <div style={{
              fontSize: '14px',
              fontWeight: 600,
              marginBottom: '16px',
              color: editingCustomPII !== null ? '#fa8c16' : '#262626',
              letterSpacing: '0.3px'
            }}>
              {editingCustomPII !== null ? '✏️ Edit Custom PII Type' : '➕ Add New Custom PII Type'}
            </div>
            <Row gutter={[16, 12]}>
              <Col span={12}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Name *
                </label>
                <input
                  type="text"
                  placeholder="e.g., Employee ID"
                  value={customPIIForm.name}
                  onChange={(e) => setCustomPIIForm({ ...customPIIForm, name: e.target.value })}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '4px', border: '1px solid #d9d9d9', fontSize: '13px' }}
                />
              </Col>
              <Col span={12}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Severity
                </label>
                <Select
                  value={customPIIForm.severity}
                  onChange={(value) => setCustomPIIForm({ ...customPIIForm, severity: value })}
                  style={{ width: '100%' }}
                  size="large"
                >
                  <Option value="critical">Critical</Option>
                  <Option value="high">High</Option>
                  <Option value="medium">Medium</Option>
                  <Option value="low">Low</Option>
                </Select>
              </Col>
              <Col span={24}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Regex Pattern *
                </label>
                <input
                  type="text"
                  placeholder="e.g., \\bEMP-\\d{6}\\b"
                  value={customPIIForm.regex}
                  onChange={(e) => setCustomPIIForm({ ...customPIIForm, regex: e.target.value })}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '4px', border: '1px solid #d9d9d9', fontFamily: 'monospace', fontSize: '13px' }}
                />
              </Col>
              <Col span={12}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Base Confidence: {customPIIForm.base_confidence}%
                </label>
                <Slider
                  min={50}
                  max={95}
                  value={customPIIForm.base_confidence}
                  onChange={(value) => setCustomPIIForm({ ...customPIIForm, base_confidence: value })}
                  marks={{ 50: { label: <span style={{ fontSize: '11px' }}>50</span> }, 70: { label: <span style={{ fontSize: '11px' }}>70</span> }, 95: { label: <span style={{ fontSize: '11px' }}>95</span> } }}
                  trackStyle={{ backgroundColor: '#1890ff', height: 4 }}
                  handleStyle={{ borderColor: '#1890ff', height: 16, width: 16, marginTop: -6, backgroundColor: '#fff' }}
                  railStyle={{ height: 4, backgroundColor: '#e8e8e8' }}
                />
              </Col>
              <Col span={12}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Context Labels (comma-separated)
                </label>
                <input
                  type="text"
                  placeholder="e.g., employee, emp id, staff number"
                  value={customPIIForm.context_labels}
                  onChange={(e) => setCustomPIIForm({ ...customPIIForm, context_labels: e.target.value })}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '4px', border: '1px solid #d9d9d9', fontSize: '13px' }}
                />
              </Col>
              <Col span={24}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: 600, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px', color: '#8c8c8c' }}>
                  Example Values (comma-separated)
                </label>
                <input
                  type="text"
                  placeholder="e.g., EMP-123456, EMP-789012"
                  value={customPIIForm.examples}
                  onChange={(e) => setCustomPIIForm({ ...customPIIForm, examples: e.target.value })}
                  style={{ width: '100%', padding: '8px 12px', borderRadius: '4px', border: '1px solid #d9d9d9', fontSize: '13px' }}
                />
              </Col>
              <Col span={24}>
                <div style={{ display: 'flex', gap: '8px' }}>
                  <Button
                    type="primary"
                    size="large"
                    disabled={!customPIIForm.name || !customPIIForm.regex}
                    onClick={() => {
                      const customType = {
                        name: customPIIForm.name,
                        regex: customPIIForm.regex,
                        severity: customPIIForm.severity,
                        base_confidence: customPIIForm.base_confidence,
                        context_labels: customPIIForm.context_labels.split(',').map(l => l.trim()).filter(l => l),
                        examples: customPIIForm.examples.split(',').map(e => e.trim()).filter(e => e)
                      };

                      let updated;
                      if (editingCustomPII !== null) {
                        // Update existing
                        updated = [...(config.custom_pii_types || [])];
                        updated[editingCustomPII] = customType;
                      } else {
                        // Add new
                        updated = [...(config.custom_pii_types || []), customType];
                      }

                      updateConfig('custom_pii_types', updated);

                      // Reset form
                      setCustomPIIForm({
                        name: '',
                        regex: '',
                        severity: 'medium',
                        base_confidence: 70,
                        context_labels: '',
                        examples: ''
                      });
                      setEditingCustomPII(null);
                    }}
                  >
                    {editingCustomPII !== null ? 'Update Custom PII Type' : 'Add Custom PII Type'}
                  </Button>
                  {editingCustomPII !== null && (
                    <Button
                      size="large"
                      onClick={() => {
                        setCustomPIIForm({
                          name: '',
                          regex: '',
                          severity: 'medium',
                          base_confidence: 70,
                          context_labels: '',
                          examples: ''
                        });
                        setEditingCustomPII(null);
                      }}
                    >
                      Cancel Edit
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Panel>
    </Collapse>
  );
}

export default CustomPIISection;
